<template>
  <div class="order-container">
    <div class="content mx-auto">
      <!-- thank you card -->
      <v-card class="tk-card col-flex align-center mb-8">
        <div class="card-text color-primary size-24 font-weight-bold">
          Danke für dein Interesse
          für dieses Elektroauto.
        </div>
        <div class="trial-text size-18 color-primary mt-2">
          Leider befinden wir uns noch in
          der Testphase und können deine
          Bestellung momentan nicht ausführen.
        </div>
      </v-card>

      <!-- confirmation card -->
      <v-card class="confirm-card col-flex align-center mb-8">
        <div v-if="showFeedback" class="card-text color-primary size-24 font-weight-bold">
          Danke für deine Unterstützung!
        </div>
        <template v-else>
          <div class="card-text color-primary size-24 font-weight-bold">
            Könntest du dir vorstellen online bei uns ein sofort verfügbares E-Auto zu
          </div>
          <div class="" style="width: 280px">
            <v-checkbox v-model="choices" label="leasen ?" value="LEASEN" hide-details></v-checkbox>
            <v-checkbox v-model="choices" label="kaufen ?" value="KAUFEN" hide-details></v-checkbox>
            <v-btn
              :loading="isLoading"
              dark
              class="mt-7 width-100 ok-btn"
              rounded
              @click="onSend"
            >
              OK
            </v-btn>
          </div>
        </template>
      </v-card>
    </div>
  </div>
</template>

<script>
import vehicles from '@/api/vehicles.json';
import { VehicleCard } from '@/components';
import api from 'axios';

export default {
  name: 'order-page',
  components: {
    VehicleCard
  },
  data() {
    return {
      id: this.$route.params.vehicleId,
      choices: [],
      isLoading: false,
      showFeedback: false
    }
  },
  computed: {
    vehicle: function() {
      return vehicles.find(v => v.id == this.id);
    }
  },
  methods: {
    onSend() {
      this.isLoading = true;
      let text = `${new Date().getTime()} - NEW CLICK`;
      if(this.choices.length > 0) {
        text += ' - ' + this.choices.join(' - ');
      }
      api.post(
        'https://hooks.slack.com/services/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',
        JSON.stringify({text})
      )
        .then(() => this.showFeedback = true)
        .catch(() => {})
        .finally(() => this.isLoading = false)
    }
  }
}
</script>

<style lang="scss" scoped>
.order-container {
  padding-top: 110px;
  background: linear-gradient(33.53deg, #022239 0%, #030E30 100%);
  background-size: 100% 275px;
  background-repeat: no-repeat;
  background-attachment: fixed;

  .content {
    width: 95%;

    .tk-card, .confirm-card {
      border-radius: 14px;
      text-align: center;
      padding-top: 29px;
      padding-bottom: 29px;

      .card-text {
        width: 314px;
        // height: 95px;
      }
      .trial-text {
        width: 314px;
      }
      .email-input {
        height: 50px;
        width: 308px;
      }
      .ok-btn {
        background: linear-gradient(15.36deg, #021325 0%, #2F5678 100%);
      }
    }
  }
}
</style>